import 'babel-polyfill';
import Vue, { createApp, configureCompat } from 'vue';
import { vMaska } from 'maska/vue';
import { LicenseManager } from 'ag-grid-enterprise';
import store from './store/index';
import router from './router';
import './vue-fontawesome';
import './vue-vee-validate';
import './index.scss';
import 'vuefinder/dist/style.css';

import { toastMixin } from './mixins/toastMixin';
import { focusDirective } from './directives/focusDirective';
import outsideClickDirective from './directives/outsideClickDirective';
import HeaderNavBar from './components/header/nav-bar/header-nav-bar.vue';
import contenteditable from 'vue-contenteditable';
import BootstrapVue from 'bootstrap-vue';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
import emitter from 'tiny-emitter/instance';
import { Form, Field } from 'vee-validate';
import { surveyPlugin } from 'survey-vue3-ui';
import VueFinder from 'vuefinder/dist/vuefinder';
import { install } from 'vue3-recaptcha-v2';

LicenseManager.setLicenseKey(
    'Using_this_{AG_Grid}_Enterprise_key_{AG-077101}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Vrm_Solutions,_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Lodgix.com}_only_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Lodgix.com}_need_to_be_licensed___{Lodgix.com}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{16_April_2026}____[v3]_[01]_MTc3NjI5NDAwMDAwMA==0546d05ea19261133ea89a53bd78abef'
);

// Vue.prototype.$event = new Vue();

Vue.use(BootstrapVue);

configureCompat({
    WATCH_ARRAY: 'suppress-warning',
    RENDER_FUNCTION: 'suppress-warning',
    INSTANCE_LISTENERS: 'suppress-warning',
    COMPONENT_FUNCTIONAL: 'suppress-warning',
    OPTIONS_BEFORE_DESTROY: 'suppress-warning',
    INSTANCE_SCOPED_SLOTS: 'suppress-warning',
    OPTIONS_DATA_MERGE: 'suppress-warning',
    COMPONENT_V_MODEL: 'suppress-warning',
    CUSTOM_DIR: 'suppress-warning',
    INSTANCE_EVENT_EMITTER: 'suppress-warning',
    ATTR_FALSE_VALUE: 'suppress-warning',
    GLOBAL_PROTOTYPE: 'suppress-warning',
    OPTIONS_DESTROYED: 'suppress-warning',
    INSTANCE_ATTRS_CLASS_STYLE: 'suppress-warning',
});

const app = createApp({
    components: {
        HeaderNavBar,
    },
});

app.config.globalProperties.$event = {
    $on: (...args) => emitter.on(...args),
    $once: (...args) => emitter.once(...args),
    $off: (...args) => emitter.off(...args),
    $emit: (...args) => emitter.emit(...args),
};
app.config.compilerOptions.delimiters = ['[[', ']]'];
app.config.compilerOptions.whitespace = 'preserve';

app.use(store);
app.use(router);
app.use(contenteditable);
app.use(surveyPlugin);
app.use(VueFinder);
app.use(install, {
    sitekey: window.RECAPTCHA_V2_PUBLIC_KEY,
});

app.component('font-awesome-icon', FontAwesomeIcon);
app.component('font-awesome-layers', FontAwesomeLayers);
app.component('font-awesome-layers-text', FontAwesomeLayersText);
app.component('validation-observer', Form);
app.component('validation-provider', Field);

app.mixin(toastMixin);

app.directive('mask', vMaska);
app.directive('focus', focusDirective);
app.directive('click-outside', outsideClickDirective);

// Vue.use(VueScrollTo);

// app.use(VueScrollTo);

app.mount('#vue-app');

export default app;
